import styled, { css } from "styled-components";
import { pxToRem, withAlpha } from "../../styles/utils";
import type { StatusBadgeAppearance } from "./StatusBadge.types";

export const StyledBadge = styled.div.withConfig({
  shouldForwardProp: (prop) => !["variant", "appearance", "asButton"].includes(prop),
})<{
  variant: "green" | "red";
  appearance: StatusBadgeAppearance;
  asButton: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: max-content;
  /* Компактная геометрия статуса — отдельный принятый паттерн, а не обычный control. */
  min-height: ${pxToRem(32)};
  height: auto;
  padding: ${pxToRem(8)} ${pxToRem(14)};
  border-radius: ${pxToRem(8)};
  font-size: ${pxToRem(13)};
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
  cursor: ${({ asButton }) => (asButton ? "pointer" : "default")};
  white-space: nowrap;

  ${({ variant, appearance }) => {
    if (appearance === "soft") {
      return variant === "green"
        ? css`
            border: 0;
            background: ${({ theme }) => withAlpha(theme.colors.success, 0.14)};
            color: ${({ theme }) => theme.colors.successText};
          `
        : css`
            border: 0;
            background: ${({ theme }) => withAlpha(theme.colors.dangerText, 0.1)};
            color: ${({ theme }) => theme.colors.dangerText};
          `;
    }

    return variant === "green"
      ? css`
          border: ${pxToRem(1)} solid ${({ theme }) => withAlpha(theme.colors.success, 0.4)};
          background: ${({ theme }) => withAlpha(theme.colors.success, 0.1)};
          color: ${({ theme }) => theme.colors.success};
        `
      : css`
          border: ${pxToRem(1)} solid ${({ theme }) => withAlpha(theme.colors.danger, 0.4)};
          background: ${({ theme }) => withAlpha(theme.colors.danger, 0.1)};
          color: ${({ theme }) => theme.colors.danger};
        `;
  }}

  &:hover {
    ${({ asButton, variant, appearance }) =>
      asButton &&
      css`
        background: ${({ theme }) => {
          if (appearance === "soft") {
            return variant === "green"
              ? withAlpha(theme.colors.success, 0.2)
              : withAlpha(theme.colors.dangerText, 0.16);
          }
          return withAlpha(
            variant === "green" ? theme.colors.success : theme.colors.danger,
            0.18,
          );
        }};
      `}
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }
`;
